import axios from 'axios';
import authHeader from "@/services/auth-header";

const API_URL = process.env.VUE_APP_API_URL;

class CheckupService {
    fetchPatientCheckupDetails(patientcheckup_code) {
        return axios.get(`${API_URL}/patientcheckups/${patientcheckup_code}`);
    }

    fetchMissedCheckupsByDoctor(doctor_id){
        return axios.get(`${API_URL}/doctors/${doctor_id}/patientcheckups/missed/today`, {headers: authHeader()})
    }

    makeCheckupCall(patientcheckup_code, is_patientcall) {
        return axios.post(`${API_URL}/patientcheckups/call`, {patientcheckup_code: patientcheckup_code, is_patientcall: is_patientcall});
    }

    terminateCall(patientcheckup_code, status){
        return axios.put(`${API_URL}/patientcheckups/${patientcheckup_code}/call/end`, {status: status},{headers: authHeader()});
    }

    editCheckupAfterCall(patientcheckup_code, checkupeditForm){
        return checkupeditForm.put(`${API_URL}/patientcheckups/${patientcheckup_code}`, {headers: authHeader()});
    }
}

export default new CheckupService();

